<app-social-shell active="none">
  <button type="button" class="so-back" (click)="back()"><i class="fa fa-arrow-left"></i> Back</button>

  @if (loading) {
    <div class="so-card so-card-pad">
      <div style="display: flex; gap: 12px; align-items: center">
        <span class="so-avatar so-skel"></span><span class="so-skel" style="width: 40%; height: 14px"></span>
      </div>
      <span class="so-skel" style="height: 14px; margin-top: 16px"></span>
      <span class="so-skel" style="height: 14px; width: 70%; margin-top: 8px"></span>
    </div>
  } @else if (notFound) {
    <div class="so-card so-empty">
      <span class="so-empty-icon"><i class="fa fa-file-o"></i></span>
      <h3>Post not found</h3>
      <p>It was deleted, or it's in a group or community you can't see.</p>
      <a class="btn btn-dark" routerLink="/social-feed">Back to the feed</a>
    </div>
  } @else if (loadFailed) {
    <div class="so-card so-empty">
      <span class="so-empty-icon"><i class="fa fa-wifi"></i></span>
      <h3>Couldn't load this post</h3>
      <button type="button" class="btn btn-theme" (click)="load()">Try again</button>
    </div>
  } @else if (post) {
    <app-social-post-card [post]="post" comments="always" (removed)="onRemoved()"></app-social-post-card>
  }
</app-social-shell>
